/**
 * Corrections desk. Corrections are generated by the corrections desk,
 * reviewed by the corrections desk, and printed by the corrections
 * desk. The corrections desk is one chair. It is facing the printer.
 */

export interface Correction {
  id: string;
  edition: string;
  universe: string;
  original: string;
  corrected: string;
  reason: string;
  published: boolean;
}

const REASONS = [
  "the noun was wrong",
  "the verb was right but early",
  "an adjective escaped review",
  "a universe was misattributed",
  "the ferry was blamed in error",
  "the mascot was paraphrased",
  "the correction required a correction",
  "editorial standards, applied retroactively",
  "the drawer mixed two editions",
  "time: the capsule said so",
];

export function makeCorrection(seed: number, original: string, corrected: string, universe = "A-1", edition = "41.2"): Correction {
  return {
    id: `corr-${String(1000 + seed)}`,
    edition,
    universe,
    original,
    corrected,
    reason: REASONS[seed % REASONS.length],
    published: seed % 3 !== 0, // every third correction is pending, like a subscription
  };
}

/** The running corrections page, newest last (print order). */
export function correctionsPage(underlying: Array<[string, string]>, universe: string): Correction[] {
  return underlying.map(([o, c], i) => makeCorrection(i, o, c, universe));
}

export function pendingCount(page: Correction[]): number {
  return page.filter((c) => !c.published).length;
}

export function correctionRate(page: Correction[]): number {
  if (page.length === 0) return 0;
  return Math.round((pendingCount(page) / page.length) * 100) / 100;
}

/** Style rule: corrections never apologize for the ferry. */
export function filterFerryApologies(page: Correction[]): Correction[] {
  return page.filter((c) => !/ferry.*(sorry|apolog)/i.test(c.corrected));
}
